export const getCanonicalPrefix = () => `${window.location.protocol}//${window.location.host}`;
